import { Pipe, PipeTransform, inject } from '@angular/core';
import { UserService } from 'taxtank-core';
import { DateTime } from 'luxon';

/**
 * Custom date pipe
 */
@Pipe({
  name: 'zonedDate',
  standalone: false
})
export class ZonedDatePipe implements PipeTransform {
  private userService = inject(UserService);

  timezone = this.userService.getCacheFirst().clientDetails?.timezone;
  

  transform(value: string | Date, format = 'dd.MM.yy'): any {
    if (!value) {
      return value;
    }

    let dateTime = typeof value === 'string' ? DateTime.fromISO(value) : DateTime.fromJSDate(value);
    if (this.timezone) {
      dateTime = dateTime.setZone(this.timezone);
    }

    return dateTime.toFormat(format);
  }
}
